var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpiredLink202Vv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "134px",
    height: "134px",
    viewBox: "0 0 134 134",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3C5B8F28-DC9B-473C-992E-F88D7532D316") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(-121.000000, -178.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "expired_link_2-02_vv",
    transform: "translate(121.000000, 178.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E8E9F3",
    cx: 66.8,
    cy: 66.8,
    r: 66.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(39.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2,49.04 C31.12,49.12 30.72,49.76 31.2,50.4 C31.2,50.48 31.28,50.48 31.28,50.48 C36.8,53.84 53.36,67.2 53.36,76.72 L53.36,96.32 L3.36,96.32 L3.36,76.72 C3.36,67.2 20.16,53.52 25.6,50.4 C25.6,50.4 25.6,50.4 25.6,50.4 C25.76,50.16 25.84,49.92 25.84,49.76 C25.84,49.36 25.6,49.04 25.6,49.04 C20.16,45.84 3.36,32.32 3.36,22.72 L3.36,3.12 L53.36,3.12 L53.36,22.72 C53.36,32.24 36.64,45.92 31.2,49.04 Z",
    id: "Path",
    fill: "#A6BBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.24,101.36 L0.08,101.36 L0.08,98.96 C0.08,97.52 1.28,96.32 2.72,96.32 L53.76,96.32 C55.12,96.32 56.32,97.44 56.32,98.88 L56.32,101.36 L56.24,101.36 Z",
    id: "Path",
    fill: "#03D3BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.68,77.92 C17.44,82.32 18.24,91.76 18.16,96.32 L3.36,96.32 L3.36,76.72 C3.36,67.2 20.16,53.52 25.6,50.4 C25.6,50.4 25.6,50.4 25.6,50.4 C25.76,50.16 25.84,49.92 25.84,49.76 C25.84,49.36 25.6,49.04 25.6,49.04 C20.16,45.84 3.36,32.32 3.36,22.72 L3.36,3.12 L13.28,3.12 L20.32,5.04 L20.32,20.56 C20.32,20.56 19.6,25.04 21.36,29.44 C23.12,33.84 26.88,47.92 26.8,49.76 C26.8,51.6 18.08,70.4 17.68,77.92 Z",
    id: "Path",
    fill: "#C5D2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.88,16.16 C43.84,16.24 38.64,16.72 30.16,18.88 C24.4,20.32 14.4,19.2 9.12,18.48 C7.28,18.24 5.6,19.68 5.6,21.52 L5.6,23.76 C5.6,30 22.4,43.52 26.8,46.96 C27.44,47.52 27.84,48.32 27.84,49.12 L27.84,83.76 C27.84,84.96 27.28,86.08 26.32,86.72 C22.8,89.2 16.96,96.32 16.96,96.32 L39.2,96.32 C39.2,96.32 33.28,89.44 29.92,86.88 C29.12,86.32 28.72,85.36 28.72,84.4 L28.72,49.12 C28.72,48.24 29.12,47.44 29.76,46.96 C34.08,43.44 50.48,29.92 50.48,23.68 L50.48,19.76 C50.56,17.76 48.88,16.16 46.88,16.16 Z",
    id: "Path",
    fill: "#3E48A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6,5.04 L2.56,5.04 C1.2,5.04 2.84217094e-15,3.92 2.84217094e-15,2.48 L2.84217094e-15,0 L56.16,0 L56.16,2.4 C56.24,3.92 55.04,5.04 53.6,5.04 Z",
    id: "Path",
    fill: "#03D3BB"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredLink202Vv);
export default __webpack_public_path__ + "static/media/expired-link-2-02-vv.b687ca764dd35d48565a5037d51220ad.svg";
export { ForwardRef as ReactComponent };